import { useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useParkingLotRemarks } from '@debbie/cortex/dist/parking/index.js';
import moment from 'moment';
import React, { useEffect } from 'react';
import THEME from '../../../theme.js';
import Badge from '../../Badge.js';
import { Col, Row } from '../../Grid/index.js';
import { Tab, TabList, TabPanel, Tabs } from '../../Tabs.js';
import Cancellations from './Cancellations.js';
import DPT from './DPT.js';
import Fee from './Fee.js';
import FeeImages from './FeeImages.js';
import ParkingLot from './ParkingLot.js';
import ParkingLotFiles from './ParkingLotFiles.js';
import ParkingLotRemarks from './ParkingLotRemarks.js';
import WorkDescriptions from './WorkDescriptions.js';
const APCOAFeeCard = (props) => {
    const { caseVoucher } = props;
    const tabIndex = JSON.parse(localStorage.getItem('APCOAtabIndex') || '0');
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const parkingLotRemarksLoadable = useParkingLotRemarks(fee?.parkingLotCode);
    const parkingLotRemarks = h.isLoaded(parkingLotRemarksLoadable)
        ? parkingLotRemarksLoadable.data
        : null;
    const parkingLotRemarksActive = parkingLotRemarks?.filter((parkingLotRemark) => !parkingLotRemark.validTo ||
        moment(parkingLotRemark.validTo).isAfter(moment()));
    return (React.createElement("div", null,
        React.createElement(Tabs, { defaultIndex: tabIndex },
            React.createElement(TabList, null,
                React.createElement(Tab, null, "Overblik"),
                React.createElement(Tab, null,
                    "Bem\u00E6rkninger til pladsen",
                    ' ',
                    parkingLotRemarksActive?.length ? (React.createElement(Badge, { theme: THEME.DANGEROUS }, parkingLotRemarksActive?.length)) : null),
                React.createElement(Tab, null,
                    "Annulleringer",
                    h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                        ' ',
                        "(",
                        fee.noOfCancellations,
                        " / ",
                        fee.maxNoOfCancellations || '-',
                        ")")) : null),
                React.createElement(Tab, null, "Digitale l\u00F8sninger"),
                React.createElement(Tab, null, "Sagsmappen")),
            React.createElement(TabPanel, null,
                React.createElement(SaveTabIndex, { index: 0 }),
                React.createElement(Row, null,
                    React.createElement(Col, { width: "4" },
                        React.createElement("h3", null, "Gebyret"),
                        React.createElement(Fee, { caseVoucher: caseVoucher })),
                    React.createElement(Col, { width: "4" },
                        React.createElement("h3", null, "Pladsen"),
                        React.createElement(ParkingLot, { caseVoucher: caseVoucher })),
                    React.createElement(Col, { width: "4" },
                        React.createElement("h3", null, "Arbejdsbeskrivelse"),
                        fee && React.createElement(WorkDescriptions, { parkingLotCode: fee.parkingLotCode }))),
                React.createElement("br", null),
                React.createElement(FeeImages, { caseVoucher: caseVoucher })),
            React.createElement(TabPanel, null,
                React.createElement(SaveTabIndex, { index: 1 }),
                React.createElement(ParkingLotRemarks, { caseVoucher: caseVoucher })),
            React.createElement(TabPanel, null,
                React.createElement(SaveTabIndex, { index: 2 }),
                React.createElement(Cancellations, { caseVoucher: caseVoucher })),
            React.createElement(TabPanel, null,
                React.createElement(SaveTabIndex, { index: 3 }),
                fee && React.createElement(DPT, { parkingLotCode: fee.parkingLotCode })),
            React.createElement(TabPanel, null,
                React.createElement(SaveTabIndex, { index: 4 }),
                React.createElement(ParkingLotFiles, { caseVoucher: caseVoucher })))));
};
export default APCOAFeeCard;
const SaveTabIndex = (props) => {
    useEffect(() => {
        localStorage.setItem('APCOAtabIndex', JSON.stringify(props.index));
    }, []);
    return null;
};
//# sourceMappingURL=APCOAFeeCard.js.map